import React, { useEffect, useState, useContext } from "react";
import CenterContainer from "../components/CenterContainer";
import AuthContext from "../AuthContext";
import { useHistory } from "react-router-dom";
import { useLanguage } from "../useLanguage";
import { LanguageContext } from "../LanguageContext";
import Footer from "../components/Footer";
import Button from "../components/Button";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faMapMarkerAlt, faPlus } from "@fortawesome/free-solid-svg-icons";
import { OpenCloseBadge } from "../components/Badge";
import { ReactComponent as UndrawLocation } from "../data/undraw_address.svg";
import { List as LoadingList } from "react-content-loader";
import { Region } from "consumerhouse-shared";

const Regions = styled.ul``;

const RegionsItem = styled.li`
    text-transform: capitalize;
    list-style: none;
    padding: 1em;
    border-radius: 1em;
    background: #0001;
    font-weight: bold;
    color: #4268ff;
    position: relative;
    font-size: 1.2em;
    cursor: pointer;
    margin: 1em 0;

    &:hover {
        background: #0003;
    }
`;

const Welcome = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
    margin: 1em;
`;

const RegionsItemArrow = styled(FontAwesomeIcon)`
    position: absolute;
    font-size: 1.5em;
    top: 0.55em;
    right: 1em;
`;

const UndrawContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 175px;
    font-size: 1.5em;
    text-align: center;
`;

export default function RegionList() {
    const { client, auth, setAuth } = useContext(AuthContext);
    const [regions, setRegions] = useState<Region[] | null>(null);
    const history = useHistory();
    const { language: languageContext } = useContext(LanguageContext);
    const language = useLanguage();

    useEffect(() => {
        (async () => {
            if (auth) {
                setRegions((await client.fetch("/region/list")).regions);
            } else {
                setRegions((await client.fetch("/region/list/public")).regions);
            }
        })();
    }, [client, languageContext]);

    return (
        <>
            <CenterContainer width="400px" style={{ minHeight: "80vh", margin: "2em 0" }}>
                {auth?.user.admin && (
                    <Button
                        icon={faPlus}
                        onClick={async () => {
                            let input = window.prompt("Geef je regio een naam:");
                            if (input) {
                                await client.fetch("/region/create", { regionName: input });
                                history.push("/");
                            }
                        }}>
                        Regio aanmaken
                    </Button>
                )}
                <UndrawContainer>
                    <UndrawLocation />
                </UndrawContainer>
                <Welcome>{language("regions-select")}</Welcome>
                {regions ? (
                    <Regions>
                        {regions.map((region) => (
                            <RegionsItem
                                onClick={async () => {
                                    let res = await client.fetch("/user/updateregion", { activeRegionName: region.name });
                                    setAuth({
                                        accessToken: auth!.accessToken,
                                        refreshToken: auth!.refreshToken,
                                        user: res.user,
                                    });
                                    history.push("/");
                                }}
                                key={region.name}>
                                {auth?.user.admin && <OpenCloseBadge open={region.open} />} <FontAwesomeIcon icon={faMapMarkerAlt} /> {region.name}
                                <RegionsItemArrow icon={faArrowRight} />
                            </RegionsItem>
                        ))}
                    </Regions>
                ) : (
                    <LoadingList style={{ margin: "2em 0" }} />
                )}
            </CenterContainer>
        </>
    );
}
